import React from 'react';
import withExperimentReport from './withExperimentReport';
import { Variant, Control } from './Variant';
import { experiment as propTypes } from './propTypes';

/**
 * Filters out variant components the user is not allocated to.
 * @param {React.Component} child The component to check.
 * @param {Number} allocation The user's allocation.
 * @return {React.Component|null}
 */
const getAllocatedVariantComponent = (child, allocation) => {
    const { v: version } = child.props;
    const noAllocation = typeof version === 'undefined' || version <= 1;

    if (noAllocation) {
        return null;
    }

    return allocation === version ? child : null;
};

const Experiment = ({ children, test, abTests = {} }) => {
    const allocation = parseInt(abTests[test] || 0, 10);
    const isControl = allocation === 1;
    const isAllocated = allocation > 0;

    if (!children) {
        return null;
    }

    return React.Children.map(children, (child) => {
        switch (child.type) {
            case Control:
                return isControl || !isAllocated ? child : null;
            case Variant:
                return getAllocatedVariantComponent(child, allocation);
            default:
                return null;
        }
    });
};

Experiment.propTypes = {
    ...propTypes,
};

export { Variant, Control };

export default withExperimentReport(Experiment);
